import React from 'react';
import { useSelector } from 'react-redux';
export default function Header(HeaderProps) {
    var showNav = useSelector(function (state) { return state.app.showNav; });
    return (React.createElement("header", null,
        React.createElement("div", { className: "logos" },
            React.createElement("a", { href: "https://www.weatherflow.com" },
                React.createElement("img", { alt: "WeatherFlow Logo", src: "/img/logo.png" })),
            " ",
            React.createElement("a", { href: "https://wwww.installernet.com" },
                React.createElement("img", { alt: "InstallerNet Logo", src: "/img/installernet-logo.png" }))),
        React.createElement("div", { className: "clearFix" }),
        HeaderProps.children));
}
